import {
  inboxStatus,
  inboxStatusThreadStatus,
  status,
  type,
} from "venuescanner-js/constants/thread";
import { isOrganiser } from "venuescanner-js/constants/user_type";

const cancelledStatuses = inboxStatusThreadStatus[inboxStatus.CLOSED].filter(
  (threadStatus) => threadStatus !== status.EXPIRED
);

export const guards = {
  isStatusQuoteRequested: ({ thread }, _event) => {
    return (
      [status.NEW, status.OPEN].includes(thread.status) &&
      thread.messages[thread.messages.length - 1].type === type.BOOK_NUDGE_HOST
    );
  },
  isStatusQuoteReceived: ({ thread }, _event) => {
    return thread.status === status.ACCEPTED;
  },
  isStatusBooked: ({ thread }, _event) => {
    return inboxStatusThreadStatus[inboxStatus.BOOKED].includes(thread.status);
  },
  isStatusNewOrOpen: ({ thread }, _event) => {
    return [status.NEW, status.OPEN].includes(thread.status);
  },
  isStatusCancelled: ({ thread }, _event) => {
    return cancelledStatuses.includes(thread.status);
  },
  isStatusExpired: ({ thread }, _event) => {
    if (isOrganiser(thread)) return false; // Organiser sees cancelled state

    const isNotCancelledButInthePast =
      !cancelledStatuses.includes(thread.status) &&
      isBeforeToday(new Date(thread.date_to));

    return status.EXPIRED === thread.status || isNotCancelledButInthePast;
  },
};

function isBeforeToday(date) {
  const today = new Date();

  today.setHours(0, 0, 0, 0);

  return date < today;
}
